import ApplyPage from "./ApplyPage";

const QUESTIONS = [
    {
        id: "experience",
        label: "У вашей компании есть опыт собственной разработки?",
        placeholder: "Несколько строк — этого достаточно.",
    },
    {
        id: "business_goal",
        label: "Какую задачу бизнеса вы хотите решить с помощью собственной разработки?",
        placeholder: "Какой результат для бизнеса вы ждёте от разработки.",
    },
    {
        id: "decision_status",
        label: "Решение уже принято или ещё есть варианты?",
        placeholder: "Если рассматриваете альтернативы — расскажите коротко.",
    },
    {
        id: "extra",
        label: "Что-то ещё хотите добавить?",
        placeholder: "Контекст, ограничения, особенности — любое полезное.",
    },
];

export default function ApplyLaunchPage() {
    return (
        <ApplyPage
            testid="apply-launch"
            eyebrow="Формат 03 · Запуск отдела"
            title={
                <>
                    Несколько вопросов{" "}
                    <span className="font-semibold">перед встречей</span>
                </>
            }
            intro="Пожалуйста, опишите коротко, что привело вас к этому решению. Ваши ответы помогут мне подготовиться к нашей встрече."
            packageName="Запуск отдела разработки"
            questions={QUESTIONS}
            emailLabel="Ваш email, чтобы я могла связаться с вами *"
        />
    );
}
